import * as AntdIcons from '@ant-design/icons';

export const CustomIcon = (type:string)=>{
    const AntdIcon: any = AntdIcons[type as keyof typeof AntdIcons]
    return <AntdIcon/>
}